import AdapterDateFns from "@date-io/date-fns";
import ArrowLeftIcon from "@material-ui/icons/ArrowLeft";
import React, { FC, useEffect, useMemo, useState } from "react";
import { DatePicker, LocalizationProvider } from "@material-ui/pickers";
import { TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";

import Select, { SelectOptionType } from "../../../../../components/elements/Select";
import { ReportTimeFrames } from "../../../../../types/campaignTypes";
import { useCampaignDashboardStyles } from "../../CampaignDashboardStylesContext";

type TimeFrameSelectorProps = {
  selectedTimeFrame: string;
  handleTimeFrameChange: (event: any) => void;
  disablePortal?: boolean;
};

const useStyles = makeStyles({
  customDateSelector: {
    display: "flex",
    alignItems: "center",

    "& button": {
      minWidth: "unset !important",
    },
  },
});

const TIME_FRAME_OPTIONS: SelectOptionType[] = [
  { label: "7 Days", value: ReportTimeFrames.DAYS_7 },
  { label: "30 Days", value: ReportTimeFrames.DAYS_30 },
  { label: "90 Days", value: ReportTimeFrames.DAYS_90 },
  { label: "All time", value: ReportTimeFrames.ALL_TIME },
];

const TimeFrameSelector: FC<TimeFrameSelectorProps> = ({
  selectedTimeFrame,
  handleTimeFrameChange,
  disablePortal = false,
}) => {
  const [customDate, setCustomDate] = useState<Date | null>(null);
  const [timeFrame, setTimeFrame] = useState<string>(selectedTimeFrame);
  const [isDateSelectorDisplayed, setIsDateSelectorDisplayed] = useState<boolean>(false);
  const classes = useStyles();
  const dashboardClasses = useCampaignDashboardStyles();

  const options = useMemo(() => TIME_FRAME_OPTIONS, []);

  useEffect(() => {
    setTimeFrame(selectedTimeFrame);
  }, [selectedTimeFrame]);

  const handleCustomDateChange = (date: Date | null) => {
    if (date) {
      setCustomDate(date);
      setTimeFrame(ReportTimeFrames.CUSTOM_DATE);
      handleTimeFrameChange({
        target: {
          value: ReportTimeFrames.CUSTOM_DATE,
          custom_date: date.toISOString(),
        },
      });
    }
  };

  const handleChange = (event: any) => {
    const { value } = event.target;

    if (value === ReportTimeFrames.CUSTOM_DATE) {
      setIsDateSelectorDisplayed(true);

      if (customDate) {
        handleCustomDateChange(customDate);
      }
    } else {
      handleTimeFrameChange(event);
    }

    setTimeFrame(value);
  };

  return !isDateSelectorDisplayed ? (
    <Select
      className={dashboardClasses.selector}
      label="Time Frame"
      value={timeFrame}
      onChange={handleChange}
      displayEmpty
      options={options}
    />
  ) : (
    <div className={classes.customDateSelector}>
      <ArrowLeftIcon onClick={() => setIsDateSelectorDisplayed(false)} />
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DatePicker
          label="Select Date"
          value={customDate}
          onChange={(date) => handleCustomDateChange(date)}
          renderInput={(params) => <TextField {...params} fullWidth />}
          PopperProps={{
            disablePortal,
          }}
        />
      </LocalizationProvider>
    </div>
  );
};

export default TimeFrameSelector;
